import { render } from "./EnrolleeRemoveSingleOnboardComponent.vue?vue&type=template&id=2d983c44&scoped=true"
import script from "./EnrolleeRemoveSingleOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeRemoveSingleOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeRemoveSingleOnboardComponent.vue?vue&type=style&index=0&id=2d983c44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d983c44"]])

export default __exports__